export default {
	start: {
		title: "Platforma AI",
		tips: "Zamień przewijanie na zarabianie! Codzienna wypłata jednym kliknięciem – Twój telefon to maszyna do pieniędzy!"
	},
	login: {
		tips: "Nie masz konta?",
		Signup: "Zarejestruj się",
		logIn: "Zaloguj się",
		Remember: "Zapamiętaj mnie",
		form: {
			label: ["Nazwa użytkownika/Telefon", "Hasło"]
		},
		forgotPassword: "Zapomniałeś hasła?",
		contactSupport: "Skontaktuj się z pomocą",
		title: "Utwórz konto",
		content: ["Potrzebujesz konta?", "Utwórz konto tutaj"]
	},
	register: {
		form: {
			label: [
				"Nazwa użytkownika",
				"Telefon",
				"Hasło transakcyjne",
				"Hasło logowania",
				"Potwierdź hasło logowania",
				"Płeć",
				"Zaproszenie",
				"E-mail",
				"Kod weryfikacyjny"
			],
			rule: {
				Username: "Nazwa użytkownika musi mieć 4-10 znaków",
				Email: "Podaj prawidłowy adres e-mail",
				Phone: "Numer telefonu musi mieć co najmniej 4 cyfry",
				ConfirmLoginPassword: "Hasła nie są zgodne",
				TradingPassword: "Hasło transakcyjne musi mieć co najmniej 6 znaków",
				LoginPassword: "Hasło logowania musi mieć co najmniej 6 znaków"
			}
		},
		sendMsg: "Kod wysłany! Sprawdź wiadomość.",
		agree: ["Zgadzam się na {0}", "Politykę prywatności, MSA", "oraz", "Warunki korzystania"],
		content: [
			"Utwórz darmowe konto",
			"Masz już konto?",
			"Zaloguj się tutaj",
			"Utwórz konto",
			"Kontynuując, akceptujesz nasze"
		]
	}
};
